<template>
    <div class="border-b border-[#eeeff2] mb-1.5 py-3">
        <span class="block text-[20px] font-[CircularBook] text-center">My Open Orders</span>
    </div>
    <div
        class="flex items-center h-[calc(100%-64px)]"
        v-if="openOrdersLoading"
    >
        <Loading />
    </div>
    <form class="flex items-center px-5 pt-2.5 pb-2" v-if="!openOrdersLoading">
        <div class="relative w-full">
            <input type="text" id="orderSearch" class="bg-white border border-[#eeeff2] text-gray-900 text-sm rounded-[5px] focus:bg-white block w-full pe-10 p-2.5" placeholder="Search" required />
            <button type="button" class="absolute inset-y-0 end-0 flex items-center pe-3">
                <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="m20.647 18.22-4.095-3.841c1.369-1.523 2.197-3.486 2.197-5.629C18.75 3.925 14.565 0 9.421 0 4.278 0 .094 3.925.094 8.75S4.278 17.5 9.42 17.5a9.653 9.653 0 0 0 6.001-2.061l4.095 3.841c.155.146.36.22.565.22a.82.82 0 0 0 .565-.22.717.717 0 0 0 0-1.06zM1.693 8.75c0-3.998 3.466-7.25 7.728-7.25s7.73 3.252 7.73 7.25S13.682 16 9.42 16c-4.262 0-7.728-3.252-7.728-7.25z" fill="#A4A6AA"/>
                </svg>
            </button>
        </div>
    </form>
    <div class="relative overflow-x-auto table-wrapper" v-if="!openOrdersLoading">
        <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 price-table whitespace-nowrap scrollable-table">
            <thead>
            <tr class="text-[#2a395a] text-[12px] font-[CircularBook] tracking-wider border-b border-[#eeeff2]">
                <th scope="col" class="ps-5 pe-2 pb-2.5">
                    <button class="flex items-center w-full gap-2.5">
                        <span>Market</span>
<!--                        <img src="@/../img/icons/sort-arrows.svg" alt="">-->
                    </button>
                </th>
                <th scope="col" class="px-2 pb-2.5">
                    <button class="flex items-center justify-end w-full gap-2.5">
                        <span>Price</span>
<!--                        <img src="@/../img/icons/sort-arrows.svg" alt="">-->
                    </button>
                </th>
                <th scope="col" class="px-2 pb-2.5">
                    <button class="flex items-center justify-end w-full gap-2.5">
                        <span>Amount</span>
<!--                        <img src="@/../img/icons/sort-arrows.svg" alt="">-->
                    </button>
                </th>
                <th scope="col" class="px-2 pb-2.5">
                    <button class="flex items-center justify-end w-full gap-2.5">
                        <span>Total</span>
<!--                        <img src="@/../img/icons/sort-arrows.svg" alt="">-->
                    </button>
                </th>
                <th scope="col" class="px-2 pb-2.5">
                    <button class="flex items-center justify-end w-full gap-2.5">
                        <span>Type</span>
<!--                        <img src="@/../img/icons/sort-arrows.svg" alt="">-->
                    </button>
                </th>
                <th scope="col" class="px-2 pb-2.5">
                    <button class="flex items-center justify-end w-full gap-2.5">
                        <span>Date</span>
<!--                        <img src="@/../img/icons/sort-arrows.svg" alt="">-->
                    </button>
                </th>
                <th scope="col" class="pe-5 px-2 pb-2.5">
                    <button class="flex items-center justify-end w-full gap-2.5">
                        <span>Cancel</span>
<!--                        <img src="@/../img/icons/sort-arrows.svg" alt="">-->
                    </button>
                </th>
                <th scope="col" class="pe-5 px-2 pb-2.5">
                </th>
            </tr>
            </thead>
            <tbody class="text-[12px] font-[CircularMedium] text-[#2a395a]">
            <tr
                v-if="openOrders.length > 0"
                class="bg-white text-right"
                v-for="openOrder in openOrders"
                :key="openOrder.id"
            >
                <td class="ps-5 pe-2 py-[0] text-[#366fed] text-left">
                    {{ openOrder.market.title_formatted }}
                </td>
                <td class="px-2 py-1">
                    {{ openOrder.price }} {{ openOrder.type === "SELL" ? openOrder.market.from_cgw_currency.slug : openOrder.market.to_cgw_currency.slug }}
                </td>

                <td class="px-2 py-1">
                    {{ openOrder.amount }} {{ openOrder.type === "SELL" ? openOrder.market.to_cgw_currency.slug : openOrder.market.from_cgw_currency.slug }}
                </td>
                <td class="px-2 py-1">
                    {{ openOrder.total }} {{ openOrder.market.to_cgw_currency.slug }}
                </td>
                <td class="px-2 py-1">
                    {{ openOrder.direction }}
                </td>
                <td class="px-2 py-1">
                    {{ computedTimezoneDate(openOrder.created_at) }}
                </td>
                <td class="ps-2 pe-5 py-1">
                    <button
                        class="text-[#cf3d3d] text-[10px] border border-[#eeeff2] rounded-[2px] px-2.5 py-.5"
                        @click="cancelOrder(openOrder)"
                    >
                        CANCEL
                    </button>
                </td>
                <td class="px-2 py-1">
                    <a :href="`/exchange/query/order/${openOrder.id}`"><font-awesome-icon :icon="['fas', 'magnifying-glass']" /></a>
                </td>
            </tr>
            <tr v-else>
                <td colspan="7" class="!py-5">
                    <div class="flex items-center justify-center text-[#a4a6aa] text-[14px] font-[CircularMedium] tracking-wide gap-2">
                        <img src="@/../img/icons/file-gray.svg" alt="">
                        <span class="block">No data Available in table</span>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>
<script setup>
import { ref, onMounted } from "vue"
import axios from "axios";
import {backendSocket} from "../../sockets";
import {globalStore} from "../../stores";
import Swal from "sweetalert2";
import moment from "moment";
import Loading from "../Loading.vue";
const openOrders = ref({})
const openOrdersLoading = ref(true);

const computedTimezoneDate = (date) => {
    return moment(date).format("YYYY-MM-DD HH:mm:ss")
}

onMounted(() => {
    if (globalStore.userId) {
        axios.get("/exchange/query/open-orders").then(({ data: { data } }) => {
            openOrders.value = data
        }).catch(({ response: {data} }) => {
            console.log(data)
        }).finally(() => {
            openOrdersLoading.value = false
        });
    }else{
        openOrdersLoading.value = false
    }

    if (globalStore.userId) {
        backendSocket.private(`exchange.${globalStore.userId}`)
            .listen('.order.updated', ({order}) => {
                const index = openOrders.value.map(e => e.id).indexOf(order.id)
                switch (order.status) {
                    case 'PLACED':
                        openOrders.value.unshift(order)
                        break
                    case 'FILLED':
                        if (index > -1) openOrders.value.splice(index, 1)
                        break;
                    case 'PARTIALLY_FILLED':
                        if (index > -1) openOrders.value[index] = order
                        break;
                }
            })
    }
})

const cancelOrder = (order) => {
    axios.post("/exchange/query/cancel-order", {order_id: order.id})
        .then(({ data: { data } }) => {
            const index = openOrders.value.map(e => e.id).indexOf(order.id)
            if (index > -1) openOrders.value.splice(index, 1)
        })
        .catch(({ response: {data} }) => {
            Swal.fire('Warning!', data.data.message, 'warning')
        });
}

const rows = 11
</script>
